// src/pages/Blog.js
import React, { useEffect, useState, useRef } from "react";
import BlogCard from "../components/BlogCard";
import partnershipPicDimo from "../assets/partnership_pic_dimo.png";
import researchPicJan25 from "../assets/research_pic_jan25.png";
import researchPicDec24 from "../assets/research_pic_dec24.png";
import articlePicEvaluation from "../assets/article_pic_evaluation.png";
import articlePic1 from "../assets/article_pic_1.png";
import reportPdf from "../assets/research/report.pdf";

const Blog = () => {
  const blogData = [
    {
      section: "Partnerships",
      title: "OpenMind x DIMO: Robotics Forward Together",
      description:
        "OpenMind & DIMO: Unlocking Cross-Machine Communication with Blockchain.",
      date: "Apr 16th, 2025",
      image: partnershipPicDimo,
      link: "https://openmindagi.substack.com/p/openmind-and-dimo-unlocking-cross",
    },
    {
      section: "Article",
      title: "Building Out Effective Agentic Evaluation Systems",
      author: "Adam Zhou",
      date: "Feb 1st, 2025",
      image: articlePicEvaluation,
      link: "https://openmindagi.substack.com/p/building-out-effective-agentic-evaluation",
    },
    {
      section: "Research",
      title:
        "A Paragraph is All It Takes: Rich Robot Behaviors from Interacting, Trusted LLMs",
      description:
        "Discover how LLMs and blockchain enable robots with rich, adaptable behaviors, human-aligned reasoning, and secure constraints through natural language communication and immutable public ledgers.",
      image: researchPicJan25,
      link: "https://arxiv.org/pdf/2412.18588",
    },
    {
      section: "Research",
      title: "Towards Trusted Autonomy: Robotics, AI, and Blockchain",
      description:
        "Explore how blockchain technologies can enable secure, verifiable autonomous systems by providing critical infrastructure for robot identity, transactions, and coordination in an AI-powered future.",
      image: researchPicDec24,
      link: reportPdf,
    },
    {
      section: "Article",
      title: "Crypto – AGI's fundamental payment and governance rail",
      author: "Jan Liphardt",
      date: "Aug 30th, 2024",
      image: articlePic1,
      link: "https://janliphardt.com",
    },
  ];

  const blogContainerRef = useRef(null);
  const [rightmostItems, setRightmostItems] = useState([]);

  useEffect(() => {
    const updateRightmostItems = () => {
      if (!blogContainerRef.current) return;

      const container = blogContainerRef.current;
      const blogCards = container.querySelectorAll(".blog-card-wrapper");
      const rightmostIndices = [];

      let currentRowY = -1;
      let rightmostXInRow = -1;
      let rightmostIndexInRow = -1;

      blogCards.forEach((card, index) => {
        const rect = card.getBoundingClientRect();

        if (currentRowY === -1 || Math.abs(rect.top - currentRowY) > 10) {
          if (rightmostIndexInRow !== -1) {
            rightmostIndices.push(rightmostIndexInRow);
          }

          currentRowY = rect.top;
          rightmostXInRow = rect.right;
          rightmostIndexInRow = index;
        } else if (rect.right > rightmostXInRow) {
          rightmostXInRow = rect.right;
          rightmostIndexInRow = index;
        }
      });

      if (rightmostIndexInRow !== -1) {
        rightmostIndices.push(rightmostIndexInRow);
      }

      setRightmostItems(rightmostIndices);
    };

    updateRightmostItems();
    window.addEventListener("resize", updateRightmostItems);

    return () => {
      window.removeEventListener("resize", updateRightmostItems);
    };
  }, []);

  return (
    <section className="flex justify-center px-12 py-12">
      <div className="max-w-[1250px]">
        <h1 className="text-5xl font-normal mb-10">BLOG</h1>
        <div className="mb-16">
          <div
            ref={blogContainerRef}
            className="flex flex-wrap gap-12 relative"
          >
            {blogData.map((item, index) => (
              <div key={index} className="w-96 relative blog-card-wrapper">
                <BlogCard {...item} />
                {index < blogData.length - 1 &&
                  !rightmostItems.includes(index) && (
                    <div className="hidden md:block absolute -right-6 top-0 h-full w-[2px] bg-gray-300"></div>
                  )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Blog;
